<div class="bg-secondary-400 max-w-full mx-auto py-2 px-3 mb-8 sm:px-6 lg:px-8">
	<div class="px-4 text-center">
		<span class="font-medium text-white text-xl">
			<ng-content></ng-content>
		</span>
	</div>
</div>

